import { render, staticRenderFns } from "./CalendarMonth.vue?vue&type=template&id=506bccc0&"
import script from "./CalendarMonth.vue?vue&type=script&lang=ts&"
export * from "./CalendarMonth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports